<template>
  <div id="Tab6" class="expectations-wrap">
    <div class="tag-badge-info">
      <span class="tag-badge-title-info pb-2 pl-3">
        VI. Expectativas del Referido
      </span>
    </div>
    <div class="dropdown-divider mt-0 pb-2 ml-3" />
    <div class="expectations-questions">
      <div class="expectation-question-item expectation-question-item-1">
        <!--        eq means for "expectation question" -->
        <div class="eq-ask">
          <strong>
            Explique cuáles son las expectativas específicas de este referido,
            considerando las metas establecidas en el PEI. ¿Qué espera lograrse
            mediante el uso de la asistencia tecnológica, que no puede
            trabajarse mediante los demás servicios provistos al estudiante y
            que afecta su ejecución académica?
          </strong>
        </div>
        <ValidationProvider
          v-slot="{ errors, invalid }"
          :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
          immediate
          name=" "
        >
          <CustomTextArea
            :id="'goals'"
            v-model="expectations.goals"
            :maxlength="maxchars"
            :classes="['eq-field']"
            :invalid="invalid"
            :error="errors[0]"
            v-bind.sync="invalid"
          />
        </ValidationProvider>
      </div>
      <div class="expectation-question-item expectation-question-item-2">
        <div class="eq-ask">
          <strong>
            La asistencia tecnológica tiene el propósito de lograr las metas y
            objetivos del PEI, para que le permita al estudiante beneficiarse
            del currículo general o de la educación especial. Resuma brevemente
            los objetivos que el COMPU entiende que requieren de algún equipo de
            asistencia tecnológica para poder lograrse.
          </strong>
        </div>
        <ValidationProvider
          v-slot="{ errors, invalid }"
          :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
          immediate
          name=" "
        >
          <CustomTextArea
            :id="'compuAccomplishableGoals'"
            v-model="expectations.compuAccomplishableGoals"
            :maxlength="maxchars"
            :classes="['eq-field']"
            :invalid="invalid"
            :error="errors[0]"
            v-bind.sync="invalid"
          />
        </ValidationProvider>
      </div>
      <div class="expectation-question-item expectation-question-item-3">
        <div class="eq-ask">
          <strong>
            Explique las estrategias utilizadas para satisfacer las necesidades
            identificadas y el porqué, según entiende, de que estas no hayan
            sido efectivas.
          </strong>
        </div>
        <ValidationProvider
          v-slot="{ errors, invalid }"
          :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
          immediate
          name=" "
        >
          <CustomTextArea
            :id="'needStrategy'"
            v-model="expectations.needStrategy"
            :maxlength="maxchars"
            :classes="['eq-field']"
            :invalid="invalid"
            :error="errors[0]"
            v-bind.sync="invalid"
          />
        </ValidationProvider>
      </div>
      <div class="expectation-question-item expectation-question-item-4">
        <div class="eq-ask">
          <strong>
            ¿A qué equipos de asistencia tecnología y/o tecnología educativa,
            que están disponibles en el salón o escuela, el estudiante tiene
            acceso?
          </strong>
        </div>
        <ValidationProvider
          v-slot="{ errors, invalid }"
          :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
          immediate
          name=" "
        >
          <CustomTextArea
            :id="'studentEquipmentAccessibility'"
            v-model="expectations.studentEquipmentAccessibility"
            :maxlength="maxchars"
            :classes="['eq-field']"
            :invalid="invalid"
            :error="errors[0]"
            v-bind.sync="invalid"
          />
        </ValidationProvider>
      </div>
      <div class="expectation-question-item expectation-question-item-5">
        <div class="eq-ask">
          <strong>
            Observaciones o información adicional del estudiante, que el equipo
            de intervención de AT debería considerar para proveer el servicio.
            (ej. si el estudiante está encamado y no puede moverse del hogar
            para ser evaluado; si en la evaluación hace falta un intérprete, u
            otras situaciones importantes que pudieran afectar el proceso de
            evaluación).
          </strong>
        </div>
        <ValidationProvider
          v-slot="{ errors, invalid }"
          :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
          immediate
          name=" "
        >
          <CustomTextArea
            :id="'serviceAdditionalInfo'"
            v-model="expectations.serviceAdditionalInfo"
            :maxlength="maxchars"
            :classes="['eq-field']"
            :invalid="invalid"
            :error="errors[0]"
            v-bind.sync="invalid"
          />
        </ValidationProvider>
      </div>
      <div class="expectation-question-item expectation-question-item-6">
        <div class="eq-ask">
          <strong>
            Estudiante y/o acompañante requiere de algún acomodo para el proceso
            de evaluación:
          </strong>
          <span class="text-danger">
            {{
              validateCommodity() ? '' : 'Debe seleccionar al menos un acomodo'
            }}
          </span>
        </div>
        <div class="eq-field conditioned-asks">
          <div class="custom-control custom-checkbox">
            <input
              id="customCheck1"
              v-model="expectations.serviceCommodityNotRequired"
              type="checkbox"
              class="custom-control-input"
              :disabled="
                expectations.serviceCommodityRequired ||
                  expectations.companionServiceCommodityRequired
              "
              @change="notRequiredCheckChange($event)"
            />
            <label class="custom-control-label" for="customCheck1">
              No se requieren acomodos para proveer el servicio
            </label>
          </div>
          <div class="custom-control custom-checkbox">
            <input
              id="customCheck2"
              v-model="expectations.serviceCommodityRequired"
              type="checkbox"
              class="custom-control-input"
              :disabled="expectations.serviceCommodityNotRequired"
              @change="serviceCommodityCheckChange($event)"
            />
            <label class="custom-control-label" for="customCheck2">
              Acomodo requerido para el estudiante
            </label>
          </div>

          <ValidationProvider
            v-slot="{ errors, invalid }"
            :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
            immediate
            name=" "
          >
            <CustomTextArea
              v-show="expectations.serviceCommodityRequired"
              :id="'serviceCommodityDescription'"
              v-model="expectations.serviceCommodityDescription"
              :maxlength="maxchars"
              :classes="['eq-field']"
              :invalid="invalid"
              :disabled="atCompletedFlag"
              :error="errors[0]"
              v-bind.sync="invalid"
            />
          </ValidationProvider>

          <div class="custom-control custom-checkbox">
            <input
              id="customCheck3"
              v-model="expectations.companionServiceCommodityRequired"
              type="checkbox"
              class="custom-control-input"
              :disabled="expectations.serviceCommodityNotRequired"
              @change="companionServiceCommodityCheckChange($event)"
            />
            <label class="custom-control-label" for="customCheck3">
              Acomodo requerido para el acompañante
            </label>
          </div>

          <ValidationProvider
            v-slot="{ errors, invalid }"
            :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
            immediate
            name=" "
          >
            <CustomTextArea
              v-show="expectations.companionServiceCommodityRequired"
              :id="'companionServiceCommodityDescription'"
              v-model="expectations.companionServiceCommodityDescription"
              :maxlength="maxchars"
              :classes="['eq-field']"
              :invalid="invalid"
              :error="errors[0]"
              :disabled="atCompletedFlag"
              v-bind.sync="invalid"
            />
          </ValidationProvider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from '@/components/common/CustomTextArea';
import store from '@/store/index';
import alert from '../../../mixin/alert.mixin';
import loading from '@/mixin/loading.mixin';
import resourcesService from '@/services/resources.js';

export default {
  name: 'Tab6',
  components: {
    CustomTextArea,
  },
  mixins: [loading, alert],
  data() {
    return {
      expectations: {
        goals: '',
        compuAccomplishableGoals: '',
        needStrategy: '',
        studentEquipmentAccessibility: '',
        serviceAdditionalInfo: '',
        serviceCommodityNotRequired: false,
        serviceCommodityRequired: false,
        serviceCommodityDescription: '',
        companionServiceCommodityRequired: false,
        companionServiceCommodityDescription: '',
      },
      peiId: 0,
      maxchars: 3000,
      ValidationTriggered: store.getters.getatValidationTriggered,
      resources: [],
    };
  },
  methods: {
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R03200110',
        'R03200109',
      ]);
    },
    notRequiredCheckChange: function(event) {
      if (event.target.checked) {
        this.expectations.serviceCommodityRequired = false;
        this.expectations.companionServiceCommodityRequired = false;
        this.expectations.serviceCommodityDescription = '';
        this.expectations.companionServiceCommodityDescription = '';
      }
    },
    serviceCommodityCheckChange: function(event) {
      if (!event.target.checked) {
        this.expectations.serviceCommodityDescription = '';
      }
    },
    companionServiceCommodityCheckChange: function(event) {
      if (!event.target.checked) {
        this.expectations.companionServiceCommodityDescription = '';
      }
    },
    getPeiAtServiceExpectations(peiAtServiceId) {
      this.$ApiGet(`/api/atservice/${peiAtServiceId}/expectations`)
        .then(
          function(res) {
            this.expectations = { ...res.data };
          }.bind(this)
        )
        .catch((err) => {
          this.response = err;
        });
    },
    save() {
      this.$ApiPost(
        `/api/atservice/${this.peiAtServiceId}/saveexpectations/${this.peiId}`,
        this.expectations
      )
        .then(
          function(res) {
            this.ShowToast(
              this.resources['R03200110'],
              this.resources['R03200109'],
              'success'
            );
            if (this.peiAtServiceId === 0) {
              //setup the id for the peiAtService recently inserted and save it into the store
              this.peiAtServiceId = res.data.id;
              store.dispatch('setSelectedAt', res.data.id);
            }
          }.bind(this)
        )
        .catch((err) => {
          this.response = err;
        });
    },
    validateCommodity() {
      if (this.ValidationTriggered.validation) {
        if (
          !this.expectations.serviceCommodityNotRequired &&
          !this.expectations.serviceCommodityRequired &&
          !this.expectations.companionServiceCommodityRequired
        ) {
          return false;
        }
      }
      return true;
    },
    validateReadMode() {
      if (!this.atCompletedFlag) {
        return;
      }

      const tags = ['input', 'button', 'textarea', 'select'];
      tags.forEach((tagName) => {
        const nodes = document
          .getElementById('Tab6')
          .getElementsByTagName(tagName);

        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true;
          nodes[i].tabIndex = -1;

          if (tagName == 'button') {
            nodes[i].style.display = 'none';
          }
        }
      });
    },
  },
  mounted() {
    this.peiId =
      store.getters.SelectedPei !== undefined ? store.getters.SelectedPei : 0;
    this.Info = this.$attrs.Info;
    if (this.peiAtServiceId !== 0) {
      this.getPeiAtServiceExpectations(this.peiAtServiceId);
    }
    this.validateReadMode();
    this.loadResources();
  },
  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
    peiAtServiceId() {
      return store.getters.SelectedAt;
    },
  },
};
</script>

<style scoped>
.expectations-questions {
  display: flex;
  flex-flow: column;
  margin-top: 30px;
}

.expectations-wrap .expectation-question-item {
  margin-bottom: 30px;
}

.expectations-wrap .expectation-question-item .eq-ask {
  margin-bottom: 15px;
}

.expectations-wrap .expectation-question-item .eq-field textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 3px;
  min-height: 118px;
}

.expectations-wrap
  .expectation-question-item
  .eq-field.conditioned-asks
  .custom-control {
  font-weight: lighter;
  margin: 12px 0;
}
</style>
